import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import LoginForm from "./pages/LoginForm";
import EmployeeForm from "./pages/EmployeeForm";
import EmployeeAttendanceCard from "./pages/EmployeeAttendance";
import SalaryAndAssetsCard from "./pages/SalaryAndAssets";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider, useAuth } from "./hooks/AuthContext";
import TaskCreatePage from "./pages/TaskCreatePage";
import DemoReportsPage from "./pages/DemoReportsPage";
import DemoCreatePage from "./pages/DemoCreatePage";
import Navigation from "./components/Navbar/Navigation";
import EmployeeListPage from "./pages/EmployeeListPage";
import EmployeeDetailPage from "./pages/EmployeeDetailPage";
import DashboardPage from "./pages/DashboardPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import EditEmployeePage from "./pages/EditEmployeePage";
import PrivacyPolicies from "./pages/PrivacyPolicies";
import ExpensesPage from "./components/Expenses/ExpancesPage";
import GrievanceList from "./components/Grievence/GrievenceList";
import GrievanceCreate from "./components/Grievence/GrievanceCreate";
import { CenterAttendance } from "./components/demos/CenterAttendance";
import CharScreen from "./components/Grievence/ChatScreen";
import ExpenceReport from "./components/Expenses/ExpenceReport";
import ViewTaskPage from "./pages/ViewTaskPage";
import AttendancePage from "./components/attendance/AttendancePage";
import ScrollToTop from "./components/ScrollToTop";
import AnshrAccountDeletion from "./pages/AnshrAccountDeletion";


const queryClient = new QueryClient();
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}
function AppRoutes() {
  const location = useLocation();
  const hideNavigationRoutes = ['/privacy-policies', '/account-deletion', '/grievance/view'];

  const shouldShowNavigation = !hideNavigationRoutes.includes(location.pathname);
  const { user } = useAuth()

  var navigate = useNavigate()

  return (
    <div className="App">
      {shouldShowNavigation && <Navigation />}
        <ScrollToTop />
      <Routes>
        <Route path="/login" element={<LoginForm />} />
        <Route path="/" element={<DashboardPage />} />
        <Route path="/employee/create" element={<EmployeeForm />} />
        <Route path="/employee/list" element={<EmployeeListPage />} />
        <Route
          path="/employee/view/:employeeId"
          element={<EmployeeDetailPage />}
        />
        <Route
          path="/employees/edit/:employeeId"
          element={<EditEmployeePage />}
        />
        <Route path="/salarycard" element={<SalaryAndAssetsCard />} />
        <Route
          path="/employeecard"
          element={<EmployeeAttendanceCard />}
        />
        <Route path="/task/create" element={<TaskCreatePage />} />
        <Route path="/view-all-tasks" element={<ViewTaskPage />} />
        
        <Route path="/demo/create" element={<DemoCreatePage />} />
        <Route path="/demo/reports" element={<DemoReportsPage />} />
        <Route
          path="/demo/attandance"
          element={
            user?.role !== "employee" ? <CenterAttendance /> : <DashboardPage />
          }
        />
        <Route path="/expences/add" element={<ExpensesPage />} />
        <Route path="/expences/report" element={<ExpenceReport />} />

        <Route path="/attendanceList" element={<AttendancePage />} />

        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />


        <Route path="/grievence-create" element={<GrievanceCreate user={user} open={true} onClose={() => navigate(-1)} />} />
        <Route path="/grievence-list" element={<GrievanceList />} />
        <Route path="/grievance/view" element={<CharScreen />} />



        <Route path="/privacy-policies" element={<PrivacyPolicies />} />
        <Route path="/account-deletion" element={<AnshrAccountDeletion />} />
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default App;

